const STORAGE_KEY = "site-migrator-density";

export type Density = "comfortable" | "cozy" | "compact";

const DENSITIES: Density[] = ["comfortable", "cozy", "compact"];

export function getStoredDensity(): Density | null {

    if (typeof window === "undefined")
        return null;

    const value = window.localStorage.getItem(STORAGE_KEY);
    return DENSITIES.includes(value as Density) ? (value as Density) : null;
}

export function getDensity(): Density {

    return getStoredDensity() ?? "comfortable";
}

export function applyInitialDensity(): void {

    document.documentElement.setAttribute("data-density", getDensity());
}

export function setDensity(density: Density): void {

    window.localStorage.setItem(STORAGE_KEY, density);
    document.documentElement.setAttribute("data-density", density);
}
